import { render, staticRenderFns } from "./TabelAdvokasi.vue?vue&type=template&id=c0c3b334"
import script from "./TabelAdvokasi.vue?vue&type=script&lang=js"
export * from "./TabelAdvokasi.vue?vue&type=script&lang=js"
import style0 from "./TabelAdvokasi.vue?vue&type=style&index=0&id=c0c3b334&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports